export default __webpack_public_path__ + "static/media/pic.0c5fbb3f.jpg";